exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0;padding:0;font-family:sans-serif;overflow:hidden}body *{box-sizing:border-box;user-select:none}.wrapper{background-color:#f5f5f5;position:absolute;top:100px;left:100px;width:900px;height:700px;border:1px solid #dadadc}#screens{position:absolute;width:100%;height:100%;overflow:auto}.screen-container{position:absolute;width:5000px;height:3000px}.scale-value{left:0}.button,.scale-value{position:absolute;bottom:100%}.button{left:100px}.button-ch{left:200px}.button-ch,.button-en{position:absolute;bottom:100%}.button-en{left:230px}#canvas{position:absolute;top:80px;left:50%;margin-left:-80px;width:160px;height:200px;background:#add8e6;transform-origin:50% 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b1e43bf","scoped":false,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserRuler.vue
// module id = 12
// module chunks = 0